import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { FormValuesType } from 'app/components/pages/Extranet/ExtranetInventory/Legacy/_components/MaxBookingConfigurationModal/MaxBookingConfigurationModal';
import { apiMutation } from 'app/utils/request/api';

import { extranetPackagePath } from '../../packages/usePackageExtranet';

const saveMaxBookingsPath = '/extranet/:hotelId/packages/max-bookings' as const;

export function useSaveMaxBookings(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: FormValuesType) =>
      apiMutation(
        'POST',
        {
          path: saveMaxBookingsPath,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: (_, payload) => {
      message.success('Max bookings saved successfully');

      queryClient.invalidateQueries([extranetPackagePath, { hotelId }]);
    },
    onError: (error) => {
      console.error('Error saving max bookings:', error);
    },
  });
}
